import { Modal, ModalCloseButton, ModalContent } from '@chakra-ui/react';
import { useSnackbar } from '@components/snackbar';
import {
  DeleteIcon,
  EmptyStateIcon,
  StartTimerIcon,
  StopTimerIcon,
  SubtaskIcon,
} from '@sketchnote/icons';
import { LoaderXs } from '@sketchnote/shared-components';
import * as dateFns from 'date-fns';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { API } from 'src/api';
interface automationProps {
  id: string;
  action: string;
  event: string;
  title: string;
  createdAt: string;
  createdBy: { firstname: string; lastname: string; role: string };
}

export const OngoingAutomations = () => {
  const { parseISO, formatRelative } = dateFns;
  const [OngoingAutomations, setOngoingAutomations] = useState<automationProps[]>([]);
  const router = useRouter();
  const [openSnackbar] = useSnackbar();
  const [isLoading, setLoader] = useState<boolean>(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<automationProps>();

  const formatResponse = (data: any) => {
    const automationData = data.map((obj) => ({
      id: obj._id,
      event: obj.automation.event,
      action: obj.automation.action,
      title: obj.automation.title,
      createdAt: obj.createdAt,
      createdBy: {
        firstname: obj.createdBy.firstname,
        lastname: obj.createdBy.lastname,
        role: obj.createdBy.role,
      },
    }));
    return automationData;
  };

  const GetOngoingAtomations = async () => {
    setLoader(true);
    const boardId = router.query.view as string;
    const response = await API.get(`/board/automation?boardId=${boardId}`);
    if (response) {
      const result: automationProps[] = formatResponse(response.data.data);
      setOngoingAutomations(result);
    }
    setLoader(false);
  };
  useEffect(() => {
    GetOngoingAtomations();
  }, []);

  const DeleteAutomation = async (item: any) => {
    const response = await API.delete(`/board/automation?id=${item.id}`);
    if (response.data.success) {
      openSnackbar({
        text: `Automation ${item.title} deleted successfully`,
        snackType: 'standard',
        position: 'bottom-center',
        duration: 1500,
      });

      setOngoingAutomations((prev) => {
        prev = prev.filter((obj) => obj.id !== item.id);
        return [...prev];
      });
    } else {
      openSnackbar({
        text: `Error deleting ${item.title}`,
        snackType: 'error',
        position: 'bottom-center',
        duration: 1500,
      });
    }
  };

  return (
    <div className="flex flex-col bg-gray-100 h-467 overflow-y-scroll no-scrollbar my-10">
      {OngoingAutomations && OngoingAutomations.length > 0 && !isLoading ? (
        OngoingAutomations.map((item, index) => {
          return (
            <div
              key={index}
              className="flex bg-gray-100 justify-between p-10 items-center hover:bg-primary-100 rounded-lg"
            >
              <span className="flex flex-col">
                <div className="flex items-center">
                  {item.title &&
                    (item.title.toLowerCase() === 'create subtask' ? (
                      <SubtaskIcon className="hover:text-primary-500" size={18} />
                    ) : item.title.toLowerCase() === 'start timer' ? (
                      <StartTimerIcon className="hover:text-primary-500" size={18} />
                    ) : item.title.toLowerCase() === 'stop timer' ? (
                      <StopTimerIcon className="hover:text-primary-500" size={18} />
                    ) : null)}

                  <span className="ml-6 font-medium text-sm">
                    {item.event && `${item.title} - ${item.event.replace(/\./g, ' ')}`}
                  </span>
                </div>
                {item.createdBy && (
                  <p className="font-regular text-xs text-gray-500">
                    Created by {item.createdBy.firstname} {item.createdBy.lastname} on{' '}
                    {formatRelative(parseISO(item.createdAt), new Date())}
                  </p>
                )}
              </span>
              {item && (
                <DeleteIcon
                  size={16}
                  className="text-gray-500"
                  onClick={() => {
                    setItemToDelete(item);
                    setIsDeleteModalOpen(true);
                  }}
                />
              )}
              <Modal
                isOpen={isDeleteModalOpen}
                onClose={() => {
                  setIsDeleteModalOpen(false);
                }}
              >
                <ModalContent
                  style={{
                    maxWidth: '46rem',
                    padding: '32px',
                    marginTop: '20rem',
                    borderRadius: '8px',
                  }}
                >
                  <ModalCloseButton />
                  <p className="mb-32 text-sm text-gray-999">
                    Are you sure you want to delete Automation?
                  </p>
                  <div className="flex justify-end mt-32">
                    <button
                      onClick={() => {
                        setIsDeleteModalOpen(false);
                      }}
                      className="border-blue-500 text-blue-500 border rounded-sm px-24 py-13 mr-8"
                    >
                      Cancel
                    </button>
                    <button
                      className="border-red-700 text-red-700 border rounded-sm px-24 py-13"
                      onClick={(e) => {
                        DeleteAutomation(itemToDelete);
                        setIsDeleteModalOpen(false);
                      }}
                    >
                      Delete
                    </button>
                  </div>
                </ModalContent>
              </Modal>
            </div>
          );
        })
      ) : isLoading ? (
        <LoaderXs className="mx-auto text-xss my-auto" />
      ) : (
        <div className="flex flex-col items-center justify-center mt-100 text-gray-600">
          <EmptyStateIcon />
          <p>You don’t have any automations configured!</p>
        </div>
      )}
    </div>
  );
};
